import Logout from "../common/Logout";
import { DownloadIconImg, DocumentShareIconImg, UploadIconImg, EditIconProject, EyeIconProjct, DeleteIconProject, ExportIconProject } from "../common/ImageConstants";
import { Link } from "react-router-dom";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { getFormattedDate, GetUser, ShowToast } from "../common/CommonController";
import { DeleteProject, ExportData, getChartData, GetDashboadDetail, shortImportStatus } from "../Shared/Controller/commonApp";
import { Chart as ChartJs, ArcElement, Tooltip } from "chart.js";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import { Card, Placeholder, Spinner } from "react-bootstrap";
import NotFound from "../common/NotFound";
import ConfirmModal from "../common/ConfirmModal";

const Home = () => {
  const DashboardChart = lazy(() => import("../dashboard/DashboardChart"));
  const userDetail = GetUser();
  const [loading, setLoading] = useState(false);
  const [dashboardDetail, setDashBoardDetail] = useState({});
  const [chartData, setChartData] = useState({});
  const [exportLoading, setExportLoading] = useState(false);
  const [exportProjectIds, setExportProjectIds] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [projectId, setProjectId] = useState("");

  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [sortBy, setSortBy] = useState("created_at");
  const [sortOrder, setSortOrder] = useState("desc");
  const [totalRows, setTotalRows] = useState(0);

  ChartJs.register(ArcElement, Tooltip);

  useEffect(() => {
    getDashboardDetail();
  }, [page, perPage, sortBy, sortOrder]);

  useEffect(() => {
    let ChartData = {};
    if (Object.keys(dashboardDetail).length !== 0) {
      ChartData = getChartData(dashboardDetail);
      setChartData(ChartData);
    }
  }, [dashboardDetail]);

  const getDashboardDetail = (customSearch = null) => {
    setLoading(true);
    GetDashboadDetail({
      per_page: perPage,
      page: page,
      search: customSearch !== null ? customSearch : searchText,
      sort_by: sortBy,
      sort_order: sortOrder
    }).then((response) => {
      if (response.data.code === 1) {
        setDashBoardDetail(response.data.data);
        setTotalRows(response.data.data.pagination?.total || 0);
      }
      else {
        if (response.data.message.constructor === Object) {
          ShowToast("object", "error", response.data.message)
        }
        else {
          ShowToast("message", "error", response.data.message)
        }
      }
      setLoading(false);
    }).catch(error => {
      setLoading(false);
      ShowToast("message", "error", "" + error);
    });
  }

  const getTableColumns = () => {
    let table_columns = [];
    if (userDetail.role === 1) {
      table_columns = [
        {
          name: "Project Name",
          selector: row => row.project_name,
          wrap: true,
          // cell: d => { return getProjectName({ ...d }) },
          width: "12%",
          sortable: true,
          sortField: "project_name"
        },
        {
          name: "Identifier",
          selector: row => row.identifier,
          wrap: true,
          // cell: d => { return getProjectName({ ...d }) },
          width: "15%",
          sortable: true,
          sortField: "identifier"
        },
        {
          name: "# Tasks",
          compact: true,
          center: true,
          selector: row => row.imported_rows,
          sortable: true,
          sortField: "imported_rows"
        },
        {
          name: "Integrity Progress",
          compact: true,
          center: true,
          selector: row => row.integrity_statustotal,
          cell: d => { return d.only_review !== 1 ? d.integrity_statustotal : "" },
          sortable: true,
          sortField: "integrity_statustotal"
        },
        {
          name: "Review Progress",
          compact: true,
          center: true,
          selector: row => row.task_statustotal,
          cell: d => { return d.only_integrity !== 1 ? d.task_statustotal : "" },
          sortable: true,
          sortField: "task_statustotal"
        },
        // {
        //   name: "Import Status",
        //   selector: row => row.import_status,
        //   sortable: true,
        //   width: "15%",
        //   sortFunction: shortImportStatus,
        //   cell: d => { return getColumnData({ type: "importstatus", item: d }) }
        // },
        // {
        //   name: "Project Status",
        //   selector: row => row.status,
        //   // compact: true,
        //   width: "15%",
        //   sortable: true,
        //   cell: d => { return getColumnData({ type: "status", item: d }) }
        // },
        {
          name: "Owner",
          selector: row => row.created_user,
          width: "10%",
          wrap: true,
          sortable: true,
          sortField: "created_user"
        },
        {
          name: "Created On",
          selector: row => row.created_at,
          width: "13%",
          wrap: true,
          cell: d => { return getFormattedDate(d.created_at) },
          sortable: true,
          sortField: "created_at"
        },
        {
          name: "PII Flag",
          selector: row => row.pll_flag,
          width: "7%",
          wrap: true,
          cell: d => { return d.pll_flag },
          sortable: true,
          sortField: "pll_flag"
        },
        {
          name: "Action",
          center: true,
          width: "28%",
          cell: d => { return getColumnData({ type: "action", item: d }) }
        }
      ]
    }
    else if (userDetail.role === 2) {
      table_columns = [
        {
          name: "Project Name",
          selector: row => row.project_name,
          // cell: d => { return getProjectName({ ...d }) },
          wrap: true,
          width: "19%",
          sortable: true,
          sortField: "project_name"
        },
        {
          name: "Identifier",
          selector: row => row.identifier,
          wrap: true,
          // cell: d => { return getProjectName({ ...d }) },
          width: "15%",
          sortable: true,
          sortField: "identifier"
        },
        // {
        //   name: "Project Status",
        //   selector: row => row.status,
        //   // width: "20%",
        //   sortable: true,
        //   cell: d => { return getColumnData({ type: "status", item: d }) }
        // },
        {
          name: "Owner",
          selector: row => row.created_user,
          width: "19%",
          wrap: true,
          sortable: true,
          sortField: "created_user"
        },
        {
          name: "Created On",
          selector: row => row.created_at,
          width: "15%",
          wrap: true,
          cell: d => { return getFormattedDate(d.created_at) },
          sortable: true,
          sortField: "created_at"
        },
        {
          name: "PII Flag",
          selector: row => row.pll_flag,
          width: "7%",
          wrap: true,
          cell: d => { return d.pll_flag },
          sortable: true,
          sortField: "pll_flag"
        },
        {
          name: "Action",
          center: true,
          width: "30%",
          cell: d => { return getColumnData({ type: "action", item: d }) }
        }
      ]
    }
    return table_columns;
  }

  const getColumnData = (data) => {
    let columnData = "";
    if (data.type === "action") {
      return (
        <div className="edit-icon text-center">
          {exportLoading === true && exportProjectIds === data.item.id &&
            <React.Fragment key={"export" + data.item.id}>
              <Spinner animation="border" role="status" size="sm">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </React.Fragment>
          }
          {exportProjectIds !== data.item.id &&
            <React.Fragment>
              {data.item.status === 1 && data.item.only_review !== 1 &&
                <Link to={"/integrity-project/" + data.item.id}
                  className={exportLoading === false ? "ms-2 edt-btn orange" : "ms-2 disabled-action edt-btn orange"}>
                  Integrity
                </Link>
              }
              {data.item.status === 1 && data.item.only_integrity !== 1 &&
                <Link to={"/review-project/" + data.item.id}
                  className={exportLoading === false ? "ms-2 edt-btn purple" : "ms-2 disabled-action edt-btn purple"}>
                  Review
                </Link>
              }
              <Link data-tooltip="View" to={"/view-project/" + data.item.id}
                className={exportLoading === false ? "ms-2" : "ms-2 disabled-action"}>
                <img src={EyeIconProjct} alt="View" title="View" />
              </Link>
              {data.item.import_status !== 0 && userDetail.role === 1 &&
                <Link to={"/edit-project/" + data.item.id} state={{ projectId: data.item.id, isEdit: true }}
                  data-tooltip="Edit"
                  className={exportLoading === false ? "ms-2" : "ms-2 disabled-action"}>
                  <img src={EditIconProject} alt="Edit" title="Edit" />
                </Link>
              }
              {userDetail.role === 1 &&
                <Link to="/" className={exportLoading === false ? "ms-2" : "ms-2 disabled-action"}
                  data-tooltip="Delete"
                  onClick={(e) => onClickDelete(e, data.item.id)}>
                  <img src={DeleteIconProject} alt="Delete" title="Delete" />
                </Link>
              }
              {data.item.status !== 3 &&  // userDetail.role === 1 &&
                <React.Fragment>
                  <Link to="/"
                    data-tooltip="Export" data-position="right"
                    className={exportLoading === false ? "ms-2" : "ms-2 disabled-action"}
                    onClick={(e) => onClickExport(e, data.item.id)}>
                    <img src={ExportIconProject} alt="Export" title="Export" />
                  </Link>
                </React.Fragment>
              }
            </React.Fragment>
          }
        </div>
      );
    }
    if (data.type === "status") {
      return (
        <>
          {data.item.status === 1 &&
            "Active"
          }{data.item.status === 2 &&
            "Completed"
          }{data.item.status === 3 &&
            "Incomplete"
          }
        </>
      );
    }

    if (data.type === "importstatus") {
      return (
        <>
          {data.item.import_status === 0 &&
            "Failed"
          }{data.item.import_status === 1 &&
            "Completed"
          }{data.item.import_status === 2 &&
            "In Progress"
          }
        </>
      );
    }
    return columnData;
  }

  const onClickExport = (e, projectId) => {
    e.preventDefault();
    setExportLoading(true);
    setExportProjectIds(projectId)

    let data = {
      projectid: projectId,
    }
    ExportData(data).then((response) => {
      if (response.data.code === 1) {
        let r = response.data.data;
        const a = document.createElement('a');
        a.setAttribute('href', r);
        a.setAttribute("download", r.split("exports/")[1]);
        a.target = "_blank";
        a.click();
        setExportLoading(false);
        setExportProjectIds("");
      }
      else {
        if (response.data.message.constructor === Object) {
          ShowToast("object", "error", response.data.message)
        }
        else {
          ShowToast("message", "error", response.data.message)
        }
        setExportLoading(false);
        setExportProjectIds("");
      }
    }).catch(error => {
      ShowToast("message", "error", "" + error);
      setExportLoading(false);
      setExportProjectIds("");
    });
  }


  const handleDelete = (e) => {
    let newData = { project_id: projectId }
    setShowModal(false);
    deleteProject(newData);
  };


  const deleteProject = (data) => {
    setLoading(true);
    DeleteProject(data).then((response) => {
      if (response.data.code === 1) {
        ShowToast("message", "success", response.data.message);
        getDashboardDetail();
      }
      else {
        if (response.data.message.constructor === Object) {
          ShowToast("object", "error", response.data.message)
        }
        else {
          ShowToast("message", "error", response.data.message)
        }
      }
    }).catch(error => {
      ShowToast("message", "error", "" + error);
    });
  }

  const onClickDelete = (e, projectId) => {
    e.preventDefault();
    setShowModal(true);
    setProjectId(projectId);
  }

  const onCloseModal = () => {
    setShowModal(false);
  }

  const data = dashboardDetail.projects_list ? dashboardDetail.projects_list : [];
  const columns = getTableColumns();
  const tableData = {
    columns,
    data
  };

  return (
    <>
      <div className="dashboard-card-wrapper">
        <ConfirmModal show={showModal}
          onCloseModal={() => onCloseModal()}
          module="project"
          confirmClick={() => handleDelete()} />
        {dashboardDetail.project_summary && loading === false &&
          <React.Fragment>
            {

            }
            <div className="row">
              <div className="col-md-12 mt-3 mt-md-0">
                <h1 className="content-title">Project Summary</h1>
              </div>
              <div className="col-md-12 col-sm-12 col-lg-12 mb-3">
                <div className="card-main p-0">
                  <div className="dark-table-wrapper table-scroll proj_table">
                  
                      {/* Custom Search Input */}
                      <div className="data-table-extensions d-flex align-items-center">
                        <div className="data-table-extensions-filter position-relative">
                        <label htmlFor="filterDataTable" className="icon"></label>                        
                        <input
                          type="text"
                          name= "filterDataTable"
                          className="filter-text w-100"
                          placeholder="Search"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              setPage(1);
                              getDashboardDetail();
                            }
                          }}                         
                        />
                       
                        {searchText && (
                          <span
                            className="clear-icon"
                            onClick={() => {
                              setSearchText("");
                              setPage(1);                                
                              getDashboardDetail("");                                
                            }}
                            style={{
                              position: "absolute",
                              right: "13px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              fontSize: "23px",
                              color: "#545454"
                            }}
                            title="Clear search"
                          >
                          ×
                          </span>
                        )}

                        </div>
                        
                        <button
                          className="ms-2"
                          title="Click to Search"
                          disabled={searchText.trim() === ""}
                          style={{
                            backgroundColor: searchText.trim() === "" ? "#f4a75f" : "#ee7608", // lighter when disabled
                            color: "white",
                            border: "none",
                            padding: "8px 12px",
                            borderRadius: "50px",
                            cursor: searchText.trim() === "" ? "default" : "pointer"
                          }}
                          onClick={() => {
                            setPage(1); // Reset to page 1 for new search
                            getDashboardDetail();
                          }}
                        >
                          Search
                        </button>

                      </div>
                    
                    { data && data.length !== 0 &&                 
                      <DataTable
                        // sortFunction={this.customSort}
                        columns={columns}
                        data={data}
                        noHeader
                        defaultSortField="name"
                        defaultSortAsc={true}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        paginationDefaultPage={page} 
                        paginationRowsPerPageOptions={[10, 20, 30, 100, 500]}                      
                        // paginationComponentOptions={paginationComponentOptions}
                        onChangePage={(page) => setPage(page)}
                        onChangeRowsPerPage={(newPerPage) => {
                          setPerPage(newPerPage);
                          setPage(1);
                        }}
                        onSort={(column, sortDirection) => {
                          if (column.sortField) {
                            setSortBy(column.sortField);
                            setSortOrder(sortDirection);
                          }
                        }}
                        highlightOnHover
                      />
                    }
                  </div>
                </div>
              </div>
              {/* <Suspense fallback={
                <Placeholder as={Card} className="col-md-6 col-sm-12 col-lg-4 p-5 text-center" animation="wave">
                  <div className="graph-box-wrapper text-center chart-content">
                  </div>
                </Placeholder>
              }>
                <DashboardChart
                  dashboardDetail={dashboardDetail}
                  chartData={chartData}
                  userDetail={userDetail}
                />
              </Suspense> */}
            </div>
          </React.Fragment>
        }
        {!dashboardDetail.project_summary && loading === false &&
          <React.Fragment>
            <div className="card-main p-5">
              <NotFound type="content" message="No Data Found" />
            </div>
          </React.Fragment>
        }
        {loading === true &&
          <div className="card-main p-5 text-center">
            <Spinner animation="border" role="status" size="lg">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        }
      </div>
      <Logout />
    </>
  )
}
export default Home;